// firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDRxEejdPPvlAyL2AhMrfBo4L4h5NALJEg",
  authDomain: "appbuilder-dashboard.firebaseapp.com",
  projectId: "appbuilder-dashboard",
  storageBucket: "appbuilder-dashboard.firebasestorage.app",
  messagingSenderId: "672121791291",
  appId: "1:672121791291:web:f4cc62b6a33127e8800d1e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

// Initialize Cloud Functions and get a reference to the service
export const functions = getFunctions(app);

export default app;